import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './AuthContext';

// 컴포넌트 임포트
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

// 페이지 임포트
import Home from './pages/Home';
import Members from './pages/Members';
import Researches from './pages/Researches';
import Projects from './pages/Projects';
import Publication from './pages/Publication';
import RegisterPublication from './pages/RegisterPublication';
import RegisterMember from './pages/RegisterMember';
import RegisterResearch from './pages/RegisterResearch';
import RegisterProject from './pages/RegisterProject';
import Login from './pages/Login';
import EditMember from './pages/EditMember';
import EditPublication from './pages/EditPublication';
import EditProject from './pages/EditProject';
import EditResearch from './pages/EditResearch';
import EditHome from './pages/EditHome';

// 메인 App 컴포넌트
function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="site">
          {/* 모든 페이지에 공통으로 표시되는 헤더 */}
          <Header />

          {/* 페이지별 콘텐츠가 여기에 표시됨 */}
          <div className="site-content-contain">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/members" element={<Members />} />
              <Route path="/researches" element={<Researches />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/publication" element={<Publication />} />
              <Route path="/login" element={<Login />} />
              
              {/* 보호된 라우트 - 관리자만 접근 가능 */}
              <Route path="/register-publication" element={
                <ProtectedRoute>
                  <RegisterPublication />
                </ProtectedRoute>
              } />
              <Route path="/register-member" element={
                <ProtectedRoute>
                  <RegisterMember />
                </ProtectedRoute>
              } />
              <Route path="/register-research" element={
                <ProtectedRoute>
                  <RegisterResearch />
                </ProtectedRoute>
              } />
              <Route path="/register-project" element={
                <ProtectedRoute>
                  <RegisterProject />
                </ProtectedRoute>
              } />
              <Route path="/edit-member/:id" element={
                <ProtectedRoute>
                  <EditMember />
                </ProtectedRoute>
              } />
              <Route path="/edit-publication/:id" element={
                <ProtectedRoute>
                  <EditPublication />
                </ProtectedRoute>
              } />
              <Route path="/edit-project/:id" element={
                <ProtectedRoute>
                  <EditProject />
                </ProtectedRoute>
              } />
              <Route path="/edit-research/:id" element={
                <ProtectedRoute>
                  <EditResearch />
                </ProtectedRoute>
              } />
              <Route path="/edit-home" element={
                <ProtectedRoute>
                  <EditHome />
                </ProtectedRoute>
              } />
            </Routes>
          </div>

          {/* 모든 페이지에 공통으로 표시되는 푸터 */}
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
